import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import type { AuditVersion } from '@/hooks/useAmazonAudit'

interface AuditVersionSelectorProps {
  versions: AuditVersion[]
  currentVersion: number | undefined
  productId: string | undefined
}

export function AuditVersionSelector({ versions, currentVersion, productId }: AuditVersionSelectorProps) {
  const { t } = useTranslation()
  const navigate = useNavigate()

  if (!productId || versions.length < 2) return null

  return (
    <div className="mb-4 pb-4 border-b border-neutral-200 dark:border-neutral-700">
      <p className="text-xs font-medium text-neutral-500 dark:text-neutral-400 mb-2 px-3">
        {t('amazonListing.versions')}
      </p>
      <select
        value={currentVersion ?? ''}
        onChange={(e) => {
          const v = versions.find(ver => ver.version_number === Number(e.target.value))
          if (v) navigate(`/v2/tools/product-listing-audit/${productId}?tab=audit&audit_id=${v.id}`)
        }}
        className="w-full px-3 py-2 bg-neutral-50 dark:bg-neutral-700 border border-neutral-200 dark:border-neutral-600 rounded-lg text-sm"
      >
        {[...versions].sort((a, b) => b.version_number - a.version_number).map(v => (
          <option key={v.id} value={v.version_number}>
            {t('amazonListing.version', { number: v.version_number })}
            {v.created_at ? ` (${new Date(v.created_at).toLocaleDateString()})` : ''}
          </option>
        ))}
      </select>
    </div>
  )
}
